/*global ajax_object */
// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import lottie from 'lottie-web';
import objectFitImages from 'object-fit-images';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
import '../blocks/elementor/animated-list/index.js'; import '../blocks/elementor/big-slider/index.js'; import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/gutenberg/acf-example-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add playsinline for mobile video
   */
  let $mobileVideo = $('.homepage-mobile-video'),
    $homepagVideo = $('.homepage-video');
  if ($mobileVideo.length) {
    $mobileVideo.find('video').attr('playsinline', '');
  }
  if ($homepagVideo.length) {
    $homepagVideo.find('video').attr('playsinline', '');
  }

  gsap.registerPlugin(ScrollTrigger);

  //draw homepage percent circles
  document.querySelectorAll('.percent-circle').forEach((circle) => {
    const length = circle.getTotalLength();

    //
    gsap.set(circle, {
      strokeDasharray: length,
      strokeDashoffset: length,
    });

    // animate
    gsap.to(circle, {
      strokeDashoffset: 0,
      duration: 1.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: circle,
        start: 'top 50%',
        toggleActions: 'play none none none',
        once: true,
      },
    });
  });

  if ($('.js-animation').length) {
    $('.js-animation').each(function () {
      const $this = $(this);
      const animationJson = $this.data('animation');

      if (!animationJson) return;

      const lottieAnimation = lottie.loadAnimation({
        container: $this[0],
        renderer: 'canvas',
        loop: true,
        autoplay: false,
        path: ajax_object.animationPath + animationJson,
        rendererSettings: {
          progressiveLoad: true,
        },
      });

      ScrollTrigger.create({
        trigger: $this[0],
        start: 'top 100%',
        onEnter: () => {
          lottieAnimation.stop();
          lottieAnimation.goToAndPlay(0, true);
        },
        onEnterBack: () => {
          lottieAnimation.stop();
          lottieAnimation.goToAndPlay(0, true);
        },
      });
    });
  }

  $('.homepage-infinite-slider').each(function () {
    let $slider = $(this);

    $slider.slick({
      infinite: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 100,
      speed: 5000,
      pauseOnHover: true,
      centerMode: true,
      centerPadding: '19%',
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            centerPadding: '5%',
          },
        },
        {
          breakpoint: 768,
          settings: {
            centerPadding: '0',
            variableWidth: true,
          },
        },
      ],
    });
  });

  //after clicking on button inside #csid-form-button find input in #csid-form and focus it
  $('#csid-form-button').on('click', function () {
    setTimeout(() => {
      $('#csid-form').find('input').focus();
    }, 600);
  });

  // const $slider = $('.need-to-know-slider');
  // const $swiper = $slider.find('.swiper');
  // const $navBtns = $slider.find('.swiper-button-next, .swiper-button-prev');
  //
  // function addHover() {
  //   $swiper.addClass('hovering');
  // }
  //
  // function removeHover() {
  //   $swiper.removeClass('hovering');
  // }
  //
  // $swiper.on('mouseenter', addHover);
  // $swiper.on('mouseleave', removeHover);
  //
  // $navBtns.on('mouseenter', addHover);
  // $navBtns.on('mouseleave', removeHover);

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();

  //find in .homepage-bottom-slider swiper slider and pause on mouseenter
  // $(
  //   '.homepage-bottom-slider .swiper, .homepage-bottom-slider .elementor-swiper-button-prev, .homepage-bottom-slider .elementor-swiper-button-next'
  // )
  //   .on('mouseenter', function () {
  //     let swiper = $('.homepage-bottom-slider .swiper')[0].swiper;
  //     if (swiper && swiper.autoplay) {
  //       swiper.autoplay.stop();
  //     }
  //   })
  //   .on('mouseleave', function () {
  //     let swiper = $('.homepage-bottom-slider .swiper')[0].swiper;
  //     if (swiper && swiper.autoplay) {
  //       swiper.autoplay.start();
  //     }
  //   });
  const selector =
    '.homepage-bottom-slider .swiper, .homepage-bottom-slider .elementor-swiper-button-prev, .homepage-bottom-slider .elementor-swiper-button-next';

  let originalSpeed = null;

  $(selector)
    .on('mouseenter', function () {
      const swiper = $('.homepage-bottom-slider .swiper')[0]?.swiper;
      if (!swiper) return;

      //record original speed
      if (originalSpeed === null) {
        originalSpeed = swiper.params.speed;
      }

      //change speed to 600ms
      swiper.params.speed = 600;

      //stop autoplay
      if (swiper.autoplay?.running) {
        swiper.autoplay.stop();
      }
    })
    .on('mouseleave', function () {
      const swiper = $('.homepage-bottom-slider .swiper')[0]?.swiper;
      if (!swiper) return;

      //bring back original speed
      if (originalSpeed !== null) {
        swiper.params.speed = originalSpeed;
      }

      //restart autoplay
      if (swiper.autoplay && !swiper.autoplay.running) {
        swiper.autoplay.start();
      }
    });
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
const $window = $(window);
const $headerContent = $('header .e-con-boxed');
//const headerContentInner = $('header .e-con-inner');
let lastScrollTop = 0;

$(window).on('scroll', function () {
  // jQuery code goes here
  const scrollY = window.scrollY;
  const y = $window.scrollTop();
  const direction = y > lastScrollTop ? 'down' : 'up';
  lastScrollTop = y;

  if (scrollY > 50) {
    $headerContent.css('top', '0');
  } else {
    //if window width less than 1024px top 66px else 55px
    if (window.innerWidth < 1024) {
      $headerContent.css('top', '66px');
      return;
    }
    $headerContent.css('top', '55px');
  }

  if (
    y > 150 &&
    direction === 'down' &&
    !$('.elementor-menu-toggle').hasClass('elementor-active')
  ) {
    $headerContent.addClass('header-leave');
  } else if (direction === 'up') {
    $headerContent.removeClass('header-leave');
  }
});
